/**
 * @generated SignedSource<<1bfc2dda5a353e29e22694d4c5571df3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespQuickFilters_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespQuickFilterDropdown_user">;
  readonly " $fragmentType": "SbRespQuickFilters_user";
};
export type SbRespQuickFilters_user$key = {
  readonly " $data"?: SbRespQuickFilters_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespQuickFilters_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespQuickFilters_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespQuickFilterDropdown_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "abda078621566ef0938dd06886ffed5e";

export default node;
